// src/ParentGuard.jsx (nieuw, of vervang je huidige)
import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "./AuthProvider";
import { useSupportViewAs } from "./supportViewAs/SupportViewAsProvider";

export const ParentGuard = () => {
  const auth = useContext(AuthContext);
  const supportViewAs = useSupportViewAs();

  if (!auth?.kcReady) return null;
  if (!auth?.authenticated) {
    auth?.keycloak?.login?.();
    return null;
  }

  const allowed = ["parent", "parent_reader"];
  if (supportViewAs?.active) return <Outlet />;
  if (!auth.userRoles?.some(r => allowed.includes(r))) {
    return <Navigate to="/403" replace />;
  }
  return <Outlet />;
};
